var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CategoryLayout',{attrs:{"label":_vm.title,"searcher":_vm.customSearcher,"show-categories":true,"show-genres":false,"show-extra":"","sort-strategy":_vm.sortStrategy,"publications":_vm.authorBooks,"custom-back-to":_vm.toPrevRouteLink,"custom-counter":_vm.customCounter},on:{"change":_vm.filterChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }